import PropTypes from 'prop-types';
import {useState, useEffect} from 'react';
import {Navigate, useLocation} from 'react-router-dom';

import {useAuth} from 'hooks/useAuth';
import {authPaths, paths} from 'routes/path';

// ----------------------------------------------------------------------

AdminGuard.propTypes = {
    children: PropTypes.node,
};

export default function AdminGuard({children}) {
    const {isLoggedIn, isUser} = useAuth();
    const {pathname} = useLocation();
    const [requestedLocation, setRequestedLocation] = useState(null);
    if (!isLoggedIn) {
        if (pathname !== requestedLocation) {
            setRequestedLocation(pathname);
        }
        return <Navigate to={authPaths.login} />;
    }

    if (requestedLocation && pathname !== requestedLocation) {
        setRequestedLocation(null);
        return <Navigate to={requestedLocation} />;
    }
    if (isUser) {
        return <Navigate to={paths.dashboard} replace />;
    }

    return <>{children}</>;
}
